<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<div class="toc-title"><b>Table of Contents</b></div>
<div class="toc1"><a href="#/xhtml/08_Prologue">Prologue</a></div>
<div class="toc1"><a href="#/xhtml/09_Part01">Part One</a></div>
<div class="toc1"><span href="#/xhtml/26_Part02" title="Link target outside of Sample">Part Two</span></div>
<div class="toc1"><span href="#/xhtml/43_Part03" title="Link target outside of Sample">Part Three</span></div>
<div class="toc1"><span href="#/xhtml/56_Part04" title="Link target outside of Sample">Part Four</span></div>
<div class="toc1"><span href="#/xhtml/60_Epilogue" title="Link target outside of Sample">Epilogue</span></div>
<div class="toc1"><span href="#/xhtml/61_Authors_Note" title="Link target outside of Sample">Author’s Note About Sedna</span></div>
<div class="toc1"><span href="#/xhtml/62_Glossary" title="Link target outside of Sample">Glossary of Inuit Words and Northern Terminology</span></div>
<div class="toc1"><span href="#/xhtml/63_About_the_Author" title="Link target outside of Sample">About the Author</span></div>
<div class="toc1"><span href="#/xhtml/64_Acknowledgments" title="Link target outside of Sample">Acknowledgments</span></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?47ad9d0b